export const ENV = process.env.VUE_APP_ENV;
export const API = process.env.VUE_APP_API;
export const BASE_API = process.env.VUE_APP_BASE;
export const SIMPKB = process.env.VUE_APP_SIMPKB;
export const COPYRIGHT = process.env.VUE_APP_COPYRIGHT || "&copy;" + new Date().getFullYear();
export const LOGO = process.env.VUE_APP_LOGO;

export const BATAS_GROUPING = process.env.VUE_APP_BATAS_GROUPING;
export const BATAS_GROUP = process.env.VUE_APP_BATAS_GROUP;

export const TAWK_SRC = process.env.VUE_APP_TAWK_SRC;
export const GMAP_KEY = process.env.VUE_APP_GMAP_KEY;
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
export const SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
export const DSN_SENTRY = process.env.VUE_APP_DSN_SENTRY;
export const GA = process.env.VUE_APP_GA;
export const MAMOTO = process.env.VUE_APP_MAMOTO;
export const MAMOTO_SITE_ID = process.env.VUE_APP_MAMOTO_SITE_ID || 0;

export const THEME_ELEARNING = {
  primary: "#009688",
  primary2: "#ced3ea",
  secondary: "#01579B",
  secondary2: "#E1F5FE",
  judul: "#4d78af",
  subjudul: "#6d9dcd",
  accent: "#5e82f4",
  error: "#f44336",
  warning: "#ffeb3b",
  info: "#2196f3",
  success: "#4caf50",
  background: "#E8EAF6",
  bgdialog: "#e2e9f0",
  banner: "#ced3ea"
};

export const THEME_ELEARNING_DARK = {
  primary: "#424242",
  secondary: "#ffffff",
  judul: "#212121",
  subjudul: "#757575",
  accent: "#0D47A1",
  error: "#f44336",
  warning: "#ffeb3b",
  info: "#2196f3",
  success: "#4caf50"
};

export const KELAMIN = [
  {
    id: "L",
    label: "Laki-laki"
  },
  {
    id: "P",
    label: "Perempuan"
  }
];

export const ROLE_ADMIN_IT = 1;
export const ROLE_ADMIN_LMS = 2; //admin lms
export const ROLE_GURU = 3; //fasil dosen
export const ROLE_ASISTEN = 4; //panitia kelas
export const ROLE_PESERTA = 5; //peserta
export const ROLE_ADMIN_PUSAT = 6;

export const ALERT_INFO = {
  diklat: {
    list: {
      judul: "Diklat",
      deskripsi:
        "<b>Info (Kelola Diklat)</b> pada menu ini Anda dapat melakukan pengelolaan diklat yang akand digunakan."
    },
    form: {
      judul: "Form Diklat",
      deskripsi:
        "<b>Info  (Kelola Diklat Baru)</b> pada menu ini Anda dapat melakukan pengelolaan diklat yang akand digunakan."
    },
    form2: {
      judul: "Form Penguna",
      deskripsi:
        "<b>Info  (Kelola Pengguna Baru)</b> pada laman ini Anda diharuskan melengkapi data pengguna yang akan ditambahkan"
    }
  },
  pengguna: {
    list: {
      judul: "Pengguna",
      deskripsi:
        "<b>Info (Kelola Pengguna)</b> pada menu ini Anda dapat melakukan pengelolaan pengguna yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pilihan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Penguna",
      deskripsi:
        "<b>Info  (Kelola Pengguna Baru)</b> pada laman ini Anda diharuskan melakukan pencarian surel user terlebih dahulu, kemudian lanjutkan dengan melengkapi data pengguna yang akan ditambahkan"
    },
    form2: {
      judul: "Form Penguna",
      deskripsi:
        "<b>Info  (Kelola Pengguna Baru)</b> pada laman ini Anda diharuskan melengkapi data pengguna yang akan ditambahkan"
    }
  },
  modul: {
    list: {
      judul: "Mapel",
      deskripsi:
        "<b>Info (Kelola Mapel)</b> pada menu ini Anda dapat melakukan pengelolaan mapel yang tersimpan dalam sistem. "
    },
    form: {
      judul: "Form Mapel",
      deskripsi:
        "<b>Info (Kelola Mapel Baru)</b> pada laman ini Anda diharuskan mengisi data yang sudah ditentukan, jika terdapat informasi belum lengkap, informasi bisa langsung disimpan dan akan dilengkapi dilain waktu"
    }
  },
  enroll: {
    list: {
      judul: "Rombel",
      deskripsi:
        "<b>Info (Kelola Rombongan Belajar)</b> pada menu ini Anda dapat melakukan pengelolaan modul yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Rombel",
      deskripsi:
        "<span class='font-weight-bold'>Info (Tambah Rombongan Belajar Baru)</span> pada laman ini Anda diharuska mengisi data yang sudah ditentukan, jika terdapat informasi belum lengkap, informasi bisa langsung disimpan dan akan dilengkapi dilain waktu"
    },
    anggota: {
      deskripsi: "Anda dapat memilih anggota rombogan belajar sesuai filter yang Anda pilih"
    }
  },
  kelas: {
    list: {
      judul: "Kelas",
      deskripsi:
        "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat melakukan pengelolaan modul yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Mapel",
      deskripsi: "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat menambahkan data kelas mata pelajaran"
    }
  },
  grup: {
    list: {
      judul: "Kelas",
      deskripsi:
        "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat melakukan pengelolaan modul yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Mapel",
      deskripsi: "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat menambahkan data kelas mata pelajaran"
    }
  },
  materi: {
    list: {
      judul: "Kelas",
      deskripsi:
        "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat melakukan pengelolaan modul yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Mapel",
      deskripsi: "<b>Info (Kelola Kelas)</b> pada menu ini Anda dapat menambahkan data kelas mata pelajaran"
    }
  },
  instansi: {
    list: {
      judul: "Instansi",
      deskripsi:
        "<span class='font-weight-bold'>Info (Kelola Instansi)</span> pada menu ini Anda dapat melakukan pengelolaan instansi yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian"
    },
    form: {
      judul: "Form Instansi",
      deskripsi:
        "<span class='font-weight-bold'>Info (Tambah Instansi Baru)</span> pada laman ini Anda diharuskan mengisi data yang sudah ditentukan"
    }
  },
  mapel: {
    list: {
      judul: "Mata Pelajaran",
      deskripsi:
        "<b>Info (Kelola Mata Pelajaran)</b> Modul ini adalah modul yang digunakan yang digunakan untuk menambahkan mata pelajaran"
    },
    form: {
      judul: "Form Mata Pelajaran",
      deskripsi:
        "<span class='font-weight-bold'>Info (Tambah Mata Pelajaran Baru)</span> pada laman ini Anda diharuska mengisi data yang sudah ditentukan, jika terdapat informasi belum lengkap, informasi bisa langsung disimpan dan akan dilengkapi dilain waktu"
    }
  },
  akses: {
    list: {
      judul: "Ruang",
      deskripsi:
        "<span class='font-weight-bold'>Info (Kelola Ruang Kelas)</span> pada menu ini Anda dapat melakukan pengelolaan ruang kelas  yang tersimpan dalam sistem. Penampilan data dapat di pilah berdasarkan pengaturan filter yang dipilih atau dengan pencarian",
      size: "14px"
    },
    form: {
      judul: "Form Ruang Kelas",
      keterangan:
        "Pada laman ini Anda dapat menambahkan Akses baru yang berisi modul-modul apa saja yang bisa diakses untuk setiap pengguna"
    }
  }
};
